import "./Header.css";
import React, { useEffect } from "react";
import LoginIcon from "./LoginIcon";
import { Layout } from "antd";
import { useSelector, useDispatch } from "react-redux";
import {
  setScrolled,
  updateTopLeftTextFromPath,
} from "../../redux/store/HeaderSlice";
import HeaderOptions from "./HeaderOptions";
import { useLocation } from "react-router-dom";

export default function Header() {
  const { Header } = Layout;
  const dispatch = useDispatch();
  const { hasScrolled, topLeftText } = useSelector((state) => state.headerBar);
  const isAuthenticated = useSelector((state) => state.oauth.isAuthenticated);

  const location = useLocation();
  const currentUrlPath = location.pathname;

  useEffect(() => {
    const scrollContainer = document.getElementById("main-scrollable-layout");

    const handleScroll = (e) => {
      const scrolled = e.target.scrollTop > 0;
      dispatch(setScrolled(scrolled));
    };

    if (scrollContainer) {
      scrollContainer.addEventListener("scroll", handleScroll);
      return () => scrollContainer.removeEventListener("scroll", handleScroll);
    }
  }, [dispatch]);

  useEffect(() => {
    console.log("Dispatching path:", currentUrlPath);
    dispatch(updateTopLeftTextFromPath(currentUrlPath));
  }, [currentUrlPath, dispatch]);

  if (!isAuthenticated) {
    return null;
  }

  return (
    <Header
      style={{
        display: "flex",
        top: "0px",
        zIndex: "100",
        position: "sticky",
        width: "100%",
        backgroundColor: currentUrlPath === "/" && "var(--primary-color)",
        boxShadow: hasScrolled
          ? currentUrlPath === "/"
            ? "0px 4px 8px rgba(3, 255, 167, 0.20) "
            : "0px 4px 8px rgba(0, 0, 0, 0.08)"
          : "none",
        transition: "box-shadow 0.3s ease",
      }}
    >
      <h2
        style={{
          alignContent: "center",
          color:
            currentUrlPath === "/"
              ? "var(--green-color)"
              : "var(--dark-green-color)",
          alignSelf: "left",
          width: "30vw",
          marginBottom: "0px",
        }}
      >
        {topLeftText}
      </h2>
      <div
        id="headerdiv-inside"
        style={{
          display: "flex",
          position: "relative",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <HeaderOptions />
        <LoginIcon />
      </div>
    </Header>
  );
}
